import { useGet } from "@albertine/api-client";
import type { Theme } from "@albertine/types/openapi/lmt";
import * as Sentry from "@sentry/react";
import { Spinner } from "@/components/ui/spinner";

type WithThemeProps = {
    themeId: string;
    renderLoading?: React.JSX.Element;
    renderOnError: React.JSX.Element;
    children: (theme: Theme) => React.JSX.Element;
};

export function WithTheme(props: WithThemeProps) {
    const { themeId, renderOnError, renderLoading, children } = props;

    const themeQuery = useGet("theme", {
        param: { themeId },
    });

    if (themeQuery.isError) {
        Sentry.captureException(themeQuery.error, {
            extra: {
                message: `WithTheme: get theme failed for id ${themeId}`,
            },
        });
        return renderOnError;
    }

    const loading = renderLoading || <Spinner />;
    if (themeQuery.isLoading) {
        return loading;
    }

    const theme = themeQuery.data;
    if (!theme) {
        return null;
    }

    return children(theme);
}
